import Vue from 'vue';

import C保有不動産Edit from '@/entries/user/pages/authorized/事業所/計画書/分析/保有不動産/保有不動産Edit/保有不動産Edit.vue';

export default Vue.extend({
  name: 'P法人保有',

  components: {
    C保有不動産Edit,
  },
});
